export default "__VITE_ASSET__BO3A49jL__"